<template>
    <div>
        <modal name="modal-planify-intervention" height="auto" width="70%" :scrollable="true">
            <div class="p-6 min-h-[50vh]">
                <div class="flex items-center justify-between mb-4 pb-4 border-b text-2xl">
                    <h2 class="font-bold">Horaires à proposer à votre client</h2>
                    <button @click="$modal.hide('modal-planify-intervention');">
                        <i class="fas fa-times text-red-500"></i>
                    </button>
                </div>
                <div v-if="planIntervention">
                    <!-- <intervention-plan-proposition :intervention-id="planInterventionId" @slot-validated="handleSlotValidated" /> -->
                    <!-- <intervention-plan-manual :intervention="planIntervention" @planned="manualPlan" /> -->
                    <planning-planner :intervention-to-plan="planInterventionId" @event-scheduled="handleEventScheduled" />
                </div>
            </div>
        </modal>
        <!-- Modale ajout / édition -->
        <modal :name="id ? id : 'modal-half-day'" width="90%" height="auto" :scrollable="true" :adaptive="true" @closed="selectedTypeIntervention = null;">
            <div class="flex items-center justify-end pb-4 text-2xl p-6">
                <button @click="$modal.hide(id ? id : 'modal-half-day');">
                    <i class="fas fa-times text-red-500"></i>
                </button>
            </div>
            <div class="px-6 pb-6 font-[system-ui] bg-white min-h-screen max-h-[90vh] overflow-y-auto">
                
                <!-- Sélection du type d'intervention -->
                <div v-if="!selectedTypeIntervention" class="flex flex-col items-center justify-center mt-16 space-y-10">
                    
                    <!-- Titre -->
                    <div class="text-center">
                        <p class="text-xs font-bold tracking-[0.3em] uppercase text-orange-500 mb-2">Nouvelle planification</p>
                        <h2 class="text-3xl font-black text-black tracking-tight">Quel type d'intervention ?</h2>
                        <div class="mt-3 w-12 h-1 bg-orange-500 mx-auto rounded-full"></div>
                    </div>
                    
                    <!-- Cartes de choix -->
                    <div class="md:flex items-stretch gap-5 w-full max-w-2xl">
                        <!-- Chantier -->
                        <button @click="selectedTypeIntervention = 'chantier'" class="group relative flex-1 text-left bg-black text-white px-8 py-8 rounded-2xl shadow-xl hover:shadow-orange-500/30 hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 overflow-hidden mb-8 md:mb-0" >
                            <div class="absolute top-0 left-0 w-full h-1 bg-orange-500"></div>
                            <div class="absolute inset-0 bg-orange-500/0 group-hover:bg-orange-500/5 transition-colors duration-300"></div>
                            
                            <div class="relative z-10">
                                <div class="w-12 h-12 bg-orange-500/10 border border-orange-500/30 rounded-xl flex items-center justify-center mb-5 group-hover:bg-orange-500 group-hover:border-orange-500 transition-all duration-300">
                                    <i class="fas fa-tools text-orange-400 group-hover:text-white text-lg transition-colors duration-300"></i>
                                </div>
                                <div class="text-lg font-black tracking-tight mb-2 group-hover:text-orange-400 transition-colors duration-300">
                                    Chantier
                                </div>
                                <div class="text-sm text-white/50 leading-relaxed font-medium">
                                    Plusieurs créneaux, plusieurs appareils, pour les gros chantiers
                                </div>
                                <div class="mt-6 flex items-center gap-2 text-orange-500 text-xs font-bold tracking-widest uppercase opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                    Sélectionner <i class="fas fa-arrow-right"></i>
                                </div>
                            </div>
                        </button>

                        <!-- Intervention simple -->
                        <button @click="selectedTypeIntervention = 'simple'" class="group relative flex-1 text-left bg-black text-white px-8 py-8 rounded-2xl shadow-xl hover:shadow-orange-500/30 hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 overflow-hidden">
                            <!-- Accent bar -->
                            <div class="absolute top-0 left-0 w-full h-1 bg-orange-500"></div>
                            <!-- Glow effect -->
                            <div class="absolute inset-0 bg-orange-500/0 group-hover:bg-orange-500/5 transition-colors duration-300"></div>
                            
                            <div class="relative z-10">
                                <div class="w-12 h-12 bg-orange-500/10 border border-orange-500/30 rounded-xl flex items-center justify-center mb-5 group-hover:bg-orange-500 group-hover:border-orange-500 transition-all duration-300">
                                    <i class="fas fa-calendar-check text-orange-400 group-hover:text-white text-lg transition-colors duration-300"></i>
                                </div>
                                <div class="text-lg font-black tracking-tight mb-2 group-hover:text-orange-400 transition-colors duration-300">
                                    Intervention de passage
                                </div>
                                <div class="text-sm text-white/50 leading-relaxed font-medium">
                                    Un créneau, un appareil, un technicien, pour les interventions rapides
                                </div>
                                <div class="mt-6 flex items-center gap-2 text-orange-500 text-xs font-bold tracking-widest uppercase opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                    Sélectionner <i class="fas fa-arrow-right"></i>
                                </div>
                            </div>
                        </button>
                    </div>
                </div>
                
                <!-- Vue Intervention Simple -->
                <div v-if="selectedTypeIntervention === 'simple'">
                    
                    <!-- Breadcrumb retour -->
                    <button
                    @click="selectedTypeIntervention = null"
                    class="group flex items-center gap-2 text-sm font-bold text-black/40 hover:text-orange-500 transition-colors duration-200 mb-6 mt-2"
                    >
                    <span class="w-7 h-7 rounded-lg border border-black/10 group-hover:border-orange-500/40 group-hover:bg-orange-50 flex items-center justify-center transition-all duration-200">
                        <i class="fas fa-arrow-left text-xs"></i>
                    </span>
                    <span class="tracking-wide uppercase text-xs">Type d'intervention</span>
                </button>
                
                <!-- Badge type sélectionné -->
                <div class="flex items-center gap-3 mb-5">
                    <span class="inline-flex items-center gap-2 bg-orange-500 text-white text-xs font-black uppercase tracking-widest px-3 py-1.5 rounded-full">
                        <i class="fas fa-calendar-check"></i> Intervention de passage
                    </span>
                </div>
                
                <div class="min-h-[50vh] rounded-2xl border border-black/8 shadow-sm overflow-hidden" style="max-height: 85vh; overflow-y: auto">
                    <planning-half-day
                    :days="$account.account.societe.open_days"
                    :heure-debut-matin="$account.account.societe.heure_ouverture ? $account.account.societe.heure_ouverture.slice(0, 5) : '08:00'"
                    heurefin-matin="12:00"
                    heure-debut-apres-midi="12:01"
                    :heure-fin-apres-midi="$account.account.societe.heure_fermeture ? $account.account.societe.heure_fermeture.slice(0, 5) : '17:00'"
                    @event-click="onEventClick"
                    @new-event="onNewEvent"
                    />
                </div>
            </div>
            
            <!-- Vue Chantier -->
            <div v-if="selectedTypeIntervention === 'chantier'">
                
                <button
                @click="selectedTypeIntervention = null"
                class="group flex items-center gap-2 text-sm font-bold text-black/40 hover:text-orange-500 transition-colors duration-200 mb-6 mt-2"
                >
                <span class="w-7 h-7 rounded-lg border border-black/10 group-hover:border-orange-500/40 group-hover:bg-orange-50 flex items-center justify-center transition-all duration-200">
                    <i class="fas fa-arrow-left text-xs"></i>
                </span>
                <span class="tracking-wide uppercase text-xs">Type d'intervention</span>
            </button>
            
            <div class="flex items-center gap-3 mb-5">
                <span class="inline-flex items-center gap-2 bg-black text-white text-xs font-black uppercase tracking-widest px-3 py-1.5 rounded-full">
                    <i class="fas fa-tools"></i> Chantier
                </span>
            </div>

            <chantier-create @chantier-created="onChantierCreated" />
        </div>
        
    </div>
</modal>

<modal :name="'modal-add-intervention'" height="auto" :scrollable="true" :adaptive="true" @closed="displayFormAddIntervention = false;">
    <div class="max-h-[98vh] min-h-[50vh] overflow-y-auto">
        <div class="flex items-center justify-between p-4 mb-4 text-lg border-b">
            <div class="text-lg font-bold">Créer une intervention</div>
            <button @click="$modal.hide('modal-add-intervention');">
                <i class="fas fa-times text-red-500"></i>
            </button>
        </div>
        <div class="p-6 pt-0 bg-white">
            <div class="mb-6">
                <div class="inline-flex bg-gray-100 rounded-2xl p-1.5 gap-1 border border-black/5">
                    <button
                        :class="[
                        'flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-medium transition-all duration-200',
                        activeTab === 'manual'
                            ? 'bg-white text-orange-600 shadow-sm'
                            : 'text-gray-500 hover:text-gray-800 hover:bg-black/5'
                        ]"
                        @click="activeTab = 'manual'"
                        type="button"
                    >
                        <i class="fas fa-list w-4 h-4"></i>
                        Manuellement
                    </button>

                    <button
                        :class="[
                        'flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-medium transition-all duration-200',
                        activeTab === 'import'
                            ? 'bg-white text-orange-600 shadow-sm'
                            : 'text-gray-500 hover:text-gray-800 hover:bg-black/5'
                        ]"
                        @click="activeTab = 'import'"
                        type="button"
                    >
                        <i class="fas fa-wand-magic-sparkles w-4 h-4"></i>
                        Importer un document
                    </button>
                    </div>
            </div>
            <div v-show="activeTab === 'manual'">
                <intervention-form v-model="formIntervention" />
                <div v-if="formIntervention.client_id && formIntervention.client_appareil_id && formIntervention.type_id && formIntervention.duree_estimee" class="flex flex-col items-center space-y-4 justify-center mt-6">
                    <template v-if="loadingAddIntervention">
                        <i class="fas fa-spinner fa-spin"></i>
                    </template>
                    <template v-if="!loadingAddIntervention">
                        <div>
                            <button :disabled="loadingAddIntervention" @click="addIntervention(1)" class="bg-red-600 text-white px-6 py-3 rounded-lg shadow hover:bg-red-700 duration-200 text-lg font-bold">
                                <i class="fas fa-check mr-1"></i> Terminer
                            </button>
                        </div>
                        <!-- <div>
                            <button :disabled="loadingAddIntervention" @click="addIntervention(0)" class="bg-slate-300 text-slate-800 px-8 py-4 rounded-lg shadow hover:bg-slate-800 hover:text-white duration-200">
                                Enregistrer et planifier plus tard
                            </button>
                        </div> -->
                    </template>
                </div>
            </div>
            <div v-show="activeTab === 'import'">
                <intervention-quick-form
                :date-intervention="formIntervention.date_intervention"
                :moment-day="formIntervention.moment_day"
                :technicien-id="formIntervention.technicien_id"
                @created="onCreatedQuickIntervention"
                />
            </div>
        </div>
    </div>
</modal>

<!-- Modal view intervention -->
<modal name="modal-view-intervention-add-intervention" height="auto" :scrollable="true" :adaptive="true" width="850px">
    <div class="p-8 overflow-y-auto max-h-[100vh]">
        <div class="flex items-center justify-between mb-4 pb-4 border-b">
            <h2 class="text-xl font-bold flex items-center gap-2">
                <i class="fas fa-folder-open text-red-600"></i>
                Intervention
            </h2>
            <button @click="$modal.hide('modal-view-intervention-add-intervention')">
                <i class="fas fa-times text-red-500"></i>
            </button>
        </div>
        
        <div v-if="selectedInterventionId">
            <intervention-view :intervention-id="selectedInterventionId" />
        </div>
    </div>
</modal>

<!-- Modal view chantier -->
<modal name="modal-view-chantier-add-intervention" height="auto" :scrollable="true" :adaptive="true" width="90%">
    <div class="p-8 overflow-y-auto max-h-[100vh]">
        <div class="flex items-center justify-between mb-4 pb-4 border-b">
            <h2 class="text-xl font-bold flex items-center gap-2">
                <i class="fas fa-folder-open text-red-600"></i>
                Chantier
            </h2>
            <button @click="$modal.hide('modal-view-chantier-add-intervention')">
                <i class="fas fa-times text-red-500"></i>
            </button>
        </div>
        
        <div v-if="selectedChantierId">
            <chantier-view :chantier-id="selectedChantierId" default-tab="interventions" />
        </div>
    </div>
</modal>
</div>
</template>

<script>
import InterventionForm from "./InterventionForm.vue";
import InterventionPlanProposition from "./InterventionPlanProposition.vue";
import InterventionPlanManual from "./InterventionPlanManual.vue";
import PlanningHalfDay from "../../Planning/Components/PlanningHalfDay.vue";
import InterventionView from "./InterventionView.vue";
import ChantierCreate from "./../../Chantier/Components/ChantierCreate.vue";
import ChantierView from "../../Chantier/Components/ChantierView.vue";
import InterventionQuickForm from "./InterventionQuickForm.vue";

export default {
    name: "ModalAddIntervention",
    components: {
        InterventionForm,
        InterventionPlanProposition,
        InterventionPlanManual,
        PlanningHalfDay,
        InterventionView,
        ChantierCreate,
        ChantierView,
        InterventionQuickForm
    },
    props: {
        id: {}
    },
    data() {
        return {
            formIntervention: {},
            loadingAddIntervention: false,
            selectedTypeIntervention: null,
            
            planPropositions: [],
            planIntervention: null,
            planInterventionId: null,
            loadingGetPlanPropositions: false,
            
            selectedInterventionId: null,
            selectedChantierId: null,

            activeTab: 'manual',
        }
    },
    methods: {
        async addIntervention(planifier) {
            this.loadingAddIntervention = true
            let response = await this.$request.post('/interventions', this.formIntervention);
            if (response && response.intervention) {
                this.$toast.success("Intervention enregistrée");
                this.$eventHub.$emit('refresh-intervention-table');
                this.$modal.hide(this.id ? this.id : 'modal-half-day');
                this.formIntervention = {}
            } else {
                this.$toast.error("Une erreur est survenue lors de l'enregistrement de l'intervention");
            }
            this.loadingAddIntervention = false
            
            this.$modal.hide(this.id ? this.id : 'modal-half-day');
            this.$modal.hide('modal-add-intervention');

            this.$eventHub.$emit('refresh-planning')
            
            // if (planifier) {
            //     this.planInterventionId = response.intervention.id;
            //     this.$modal.show('modal-planify-intervention', { intervention_id: response.id });
            
            //     let mapIntervention = {...response.intervention}
            //     mapIntervention.adresse = (mapIntervention.adresse?.code_postal || '-') + " " + (mapIntervention.adresse?.ville || '-');
            //     mapIntervention.client_adresse = response.intervention.adresse;
            //     this.planIntervention = mapIntervention;
            // }
            
            this.$eventHub.$emit('refresh-pastilles', 'interventions_a_planifier')
        },
        
        handleSlotValidated() {
            this.$modal.hide('modal-planify-intervention');
            this.$eventHub.$emit('refresh-intervention-table');
        },
        
        manualPlan() {
            this.$modal.hide('modal-planify-intervention');
            this.$eventHub.$emit('refresh-intervention-table');
        },
        
        handleEventScheduled() {
            this.$modal.hide('modal-planify-intervention');
            this.$eventHub.$emit('refresh-intervention-table');
            this.$toast.success("Intervention planifiée");
        },
        
        onEventClick(event) {
            if (!event.interventionId) {
                return;
            }
            this.selectedInterventionId = event.interventionId;
            this.$modal.show('modal-view-intervention-add-intervention');
        },
        
        onNewEvent(payload) {
            this.formIntervention = {
                technicien_id: payload.techId,
                date_intervention: payload.date,
                moment_day: payload.slot
            };
            this.$modal.show('modal-add-intervention');
        },

        onChantierCreated(chantier) {
            this.selectedTypeIntervention = null;
            this.$modal.hide(this.id ? this.id : 'modal-half-day');
            this.$toast.success("Chantier créé avec succès");
            this.$eventHub.$emit('refresh-intervention-table');
            this.selectedChantierId = chantier.id;
            this.$nextTick(() => {
                this.$modal.show('modal-view-chantier-add-intervention')
            });
        },

        onCreatedQuickIntervention() {
            this.selectedTypeIntervention = null;
            this.$modal.hide('modal-add-intervention');
            this.$modal.hide(this.id ? this.id : 'modal-half-day');
            this.$toast.success("Intervention créée avec succès");
            this.$eventHub.$emit('refresh-intervention-table');
            this.$eventHub.$emit('refresh-pastilles', 'interventions_a_planifier');
        },
    },
}
</script>

<style lang="scss" scoped>

</style>